// OpenAI client that uses server-side proxy for security
// API key is stored securely on the server (Vercel Serverless Function)

import { supabase } from './supabaseClient';

export async function fetchOpenAIText({ prompt, temperature = 0.7, maxTokens = 800, model }) {
  if (!prompt) {
    throw new Error('Prompt is required');
  }

  const envModel = typeof process !== 'undefined' ? (process.env?.REACT_APP_OPENAI_MODEL || '') : '';
  const desiredModel = (model || envModel || '').trim();

  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error('You must be logged in to use this feature.');
  }

  try {
    // Call our serverless function proxy instead of OpenAI directly
    const res = await fetch('/api/openai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        prompt,
        temperature,
        maxTokens,
        model: desiredModel || undefined,
      }),
    });

    const data = await safeParseJSON(res);

    if (!res.ok) {
      const message = data?.error || data?.message || JSON.stringify(data);
      throw new Error(`OpenAI Proxy ${res.status}: ${message}`);
    }
    
    const content = data?.content || '';
    return String(content).trim();
  } catch (error) {
    throw error;
  }
}

async function safeParseJSON(res) {
  try {
    return await res.json();
  } catch (_) {
    try {
      const text = await res.text();
      return { raw: text };
    } catch (e) {
      return { error: { message: 'Failed to parse OpenAI response' } };
    }
  }
}


